module.exports = __webpack_public_path__ + "static/media/7.1.3. ESQUEMA DE PUBLICACION DE LA INFORMACION NOTARTIA (2).339984d6.pdf";